import React, { memo } from 'react';
import { SheetBottom } from '@nexus/lib-react/dist/core/SheetBottom/SheetBottom';

import trackingKeys from '../../../../commons/constants/trackingKeys';
import { TrackEvent } from '../../../ad/components/types/index';
import useI18n from '../../../../i18n/hooks/useI18n';
import S from './style/PaymentCard';

interface Props {
  desktop: boolean;
  extraTrackingParams: Record<string, any>;
  infoContent: string;
  trackEvent: TrackEvent;
}

const InfoIconWrapper: React.FC<Props> = ({
  desktop,
  infoContent,
  trackEvent,
  extraTrackingParams,
}) => {
  const i18n = useI18n();

  const [tooltipVisible, setTooltipVisible] = React.useState<boolean>(false);

  const toggleTooltip = () => {
    if (!tooltipVisible) {
      trackEvent(trackingKeys.events.tooltip_take_rate, null, null, extraTrackingParams);
    } else {
      trackEvent(trackingKeys.events.tooltip_take_rate_close, null, null, extraTrackingParams);
    }
    setTooltipVisible(!tooltipVisible);
  };

  const closeInfoSection = () => {
    trackEvent(trackingKeys.events.tooltip_take_rate_close, null, null, extraTrackingParams);
    setTooltipVisible(false);
  };

  const InfoIcon = () => (
    <S.InfoIcon data-cy="sellerTR-info" data-testid="info-icon" size={24} onClick={toggleTooltip} />
  );

  return desktop ? (
    <S.StyledTooltip
      content={infoContent}
      visible={tooltipVisible}
      placement="top-start"
      onClickOutside={closeInfoSection}
    >
      <InfoIcon />
    </S.StyledTooltip>
  ) : (
    <>
      <InfoIcon />
      <SheetBottom
        closeButtonText={i18n`dlv_got_it`}
        isVisible={tooltipVisible}
        onClose={closeInfoSection}
        data-cy="seller-take-rate-modal-mobile"
        data-testid="seller-take-rate-modal-mobile"
      >
        <S.MobileContent>
          <S.MobileTitle>{i18n`dlv_orders_details_seller_tr_fee_name`}</S.MobileTitle>
          <br />
          <span>{infoContent}</span>
        </S.MobileContent>
      </SheetBottom>
    </>
  );
};

export default memo(InfoIconWrapper);
